export const toOptions = (data, valueKey, labelKey) => {
  return data.map((item) => {
    const value = typeof valueKey === 'string' ? item[valueKey] : valueKey(item);
    const label = typeof labelKey === 'string' ? item[labelKey] : labelKey(item);

    return { value, label };
  });
};

export function getCookie(cName) {
  const name = cName + '=';
  const cDecoded = decodeURIComponent(document.cookie); //to be careful
  const cArr = cDecoded.split('; ');
  let res;
  cArr.forEach((val) => {
    if (val.indexOf(name) === 0) res = val.substring(name.length);
  });
  return res;
}
